import React, { useState } from "react";

import Container from "@mui/material/Container";
import ApplicationPanel from "../../application/ApplicationPanel";
import ApplicationHeader from "../../application/ApplicationHeader";
import ContentIngestionJobBrowse from "./ContentIngestionJobBrowse";
import { useDiscoverySearch } from "./processingDiscoveryServices";
import { Route, Routes, useNavigate, useResolvedPath } from "react-router-dom";
import RequireRoles from "../../auth/RequireRoles";
import ContentIngestionJobDetailView from "./ContentIngestionJobDetailView";
import { pickBy } from "ramda";
import { DateTime } from "luxon";
import { notBlank } from "../../util/ext";
import ContentIngestionChunkDetailView from "./ContentIngestionChunkDetailView";

const ADMIN = ["ROLE_ADMIN"];

const generateStartDate = () =>
  DateTime.utc().minus({ days: 1 }).startOf("day");

const ContentIngestionReportingView = () => {
  const path = useResolvedPath(".").pathname;
  const navigate = useNavigate();

  const initialSearchState = {
    orderBy: null,
    orderDirection: "asc",
    startDate: generateStartDate(),
    endDate: DateTime.now(),
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useDiscoverySearch(
    pickBy(notBlank, {
      startDate: searchState.startDate,
      endDate: searchState.endDate,
      filename: searchState.filename,
      status: searchState.status,
    }),
  );

  return (
    <Container id="metadata-file-discovery" disableGutters>
      <ApplicationHeader />

      <Routes>
        <Route
          path=":jobId/:chunkId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-chunk-detail">
                <ContentIngestionChunkDetailView
                  onCancel={() => navigate(path)}
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          path=":jobId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-job-detail">
                <ContentIngestionJobDetailView
                  onCancel={() => navigate(path)}
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          index
          element={
            <ApplicationPanel id="application-panel-content-ingestion-report">
              <ContentIngestionJobBrowse
                searchState={searchState}
                onSearchStateChange={state => setSearchState(state)}
                searchResults={searchResults}
              />
            </ApplicationPanel>
          }
        />
      </Routes>
    </Container>
  );
};

export default ContentIngestionReportingView;
